import { Button, FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../lib/ctx/stats'
import { StatsWebViewHooks } from '../StatsWebViewHooks'

export interface Props {
  text?: string
  allowRetry?: boolean
}

export const StatsError = ({ text, allowRetry = false }: Props) => {
  const [isProfileView, isDesktop] = useStats((s) => [
    s.isProfileView,
    s.isDesktop,
  ])
  const { colors } = useTheme()

  return (
    <>
      {isDesktop ? null : <StatsWebViewHooks />}
      <FlexBox
        className={css`
          padding: ${isProfileView ? '40px' : '0px'} 20px;
          width: 100%;
          height: ${isProfileView ? 'auto' : '100dvh'};
          align-items: ${isProfileView ? 'flex-start' : 'center'};
        `}
        justifyContent="center"
      >
        <FlexBox
          className={css`
            width: 100%;
            max-width: 260px;
            gap: 20px;
          `}
          flexDirection="column"
          alignItems="center"
        >
          <Text
            type="header"
            sizing="S"
            color={colors.uiGraphite}
            align="center"
          >
            {text}
          </Text>
          {allowRetry ? (
            <Button
              className={css`
                width: 152px;
              `}
              onClick={() => window.location.reload()}
            >
              Try again
            </Button>
          ) : null}
        </FlexBox>
      </FlexBox>
    </>
  )
}
